import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleWideSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubbleWideSparkle"><Path d="M19.4 2H18.6L17.6 4.6L15 5.6V6.4L17.6 7.4L18.6 10H19.4L20.4 7.4L23 6.4V5.6L20.4 4.6L19.4 2Z" fill="currentColor"/><Path d="M16.6084 3L16.4395 3.43945L13.5 4.56934V7.43066L16.4395 8.55957L17.5693 11.5H20.4307L21.5596 8.55957L22 8.38965V19H15.2861L11.9951 21.7266L8.74316 19H2V3H16.6084Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleWideSparkle;
